import React from "react";
import { motion } from "framer-motion";

import "../Styles/Services.css";
import bgImage from "../Assets/bg-1.webp";

const services = [
  {
    title: "Software Development",
    description:
      "Our expert in-house team uses cutting edge technologies to build softwares and custom web applications that are stunning, robust and scalable.",
    icon: "💻",
  },
  {
    title: "UX Design",
    description:
      "Great online experiences happen only when a well planned UX strategy is visualized with top class design aesthetics; and we do it best.",
    icon: "🎨",
  },
  {
    title: "Mobile App",
    description:
      "Our profound knowledge of mobile technologies & frameworks, help us create secure & scalable Mobile Apps with great UX.",
    icon: "📱",
  },
  {
    title: "Web Development",
    description:
      "Technological expertise coupled with award-winning UX skills is what makes us the leading web development company in India - and helps us build world class websites and web applications.",
    icon: "🌐",
  },
  {
    title: "Branding",
    description:
      "Our highly creative team of designers always excels in creating unique brand identity and out-of-the-box designs that speaks on its own!",
    icon: "🖌️",
  },
  {
    title: "Video Productions",
    description:
      "We create awesome explainer videos of all types, that'd improve your brand storytelling & user engagement which results in higher conversions.",
    icon: "🎬",
  },
  {
    title: "Digital Marketing",
    description:
      "We're a Google Partner and we offer unique digital marketing solutions that'd load your inbox with inquiries.",
    icon: "📢",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const Services = () => {
  return (
    <section
      className="services"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay">
        <div className="about-header fade-up">
          <h2>About</h2>
          <p>
            DD Digital Construction is Tamil Nadu's leading digital marketing
            agency, specializing in innovative strategies for real estate,
            e-commerce, and education. We deliver measurable results through
            SEO, social media, and brand development, helping businesses thrive
            in the digital landscape.
          </p>
        </div>

        <div className="services-container1">
          {services.map((service, index) => {
            let extraClass =
              index === 0 || index === 2 || index === 4 || index === 6
                ? "card-up"
                : index === 3
                ? "card-down"
                : "";

            return (
              <motion.div
                className={`service-card ${extraClass}`}
                key={index}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
              >
                <div className="icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
